import { RoutePath } from '../../enums/RoutePath';

export const scheduledPaths = [RoutePath.Scheduled, RoutePath.MasterCalendar];
